import { render } from "./CrudDemo.vue?vue&type=template&id=7316c44c&scoped=true"
import script from "./CrudDemo.vue?vue&type=script&lang=js"
export * from "./CrudDemo.vue?vue&type=script&lang=js"

import "./CrudDemo.vue?vue&type=style&index=0&id=7316c44c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Tracker Eticket\\Tracker_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7316c44c"]])

export default __exports__